/**
 * Number / currency formatters dùng chung cho dashboard widget.
 *
 * Canonical implementations live in `src/lib/format.ts`. This module
 * preserves the short legacy aliases (`vnd`, `vndCompact`, `intVN`,
 * `monthLabel`) so existing widget imports keep working without a
 * mass rename PR.
 */

import {
  formatVND,
  formatVNDChart,
  formatIntVN,
  formatMonthLabel,
} from "@/lib/format";

export const vnd = formatVND;
export const vndCompact = formatVNDChart;
export const intVN = formatIntVN;
export const monthLabel = formatMonthLabel;
